var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.500076C9.39052 0.109551 10.0237 0.109552 10.4142 0.500076L18.2071 8.29297C18.5976 8.68349 18.5976 9.31666 18.2071 9.70718L10.4142 17.5001C10.0237 17.8906 9.39052 17.8906 9 17.5001C8.60948 17.1096 8.60948 16.4764 9 16.0859L15.0858 10.0001H1C0.447715 10.0001 0 9.55236 0 9.00008C0 8.44779 0.447715 8.00008 1 8.00008H15.0858L9 1.91429C8.60948 1.52376 8.60948 0.8906 9 0.500076Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.0ed77105f361819a4a754bac72e878b6.svg";
export { ForwardRef as ReactComponent };